// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"e4c7322e","977":"3b692734"}[chunkId] + ".chunk.js";
};